var toString = require('../to-string');

var upperCase = function upperCase(str) {
  return toString(str).toUpperCase();
};

module.exports = upperCase;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/util/lib/string/upper-case.js
// module id = 159
// module chunks = 0 1 2